import { writable } from 'svelte/store';

export const margCorrect = writable({});

export const formEntries = writable({});

export const formSubmitted = writable(false);

export const scrollTrigger = writable(false);

export const starData = writable([]);

export const indSlide = writable(-1);

export const indSel = writable({i:-1,h:-1});